import * as React from 'react'
import { RuntimeFabricSettingsIcon } from './RuntimeFabricSettingsIcon'
import './RuntimeFabricSettingsPage.css'

export type ValueProps = {}

export type EventProps = {}

export type Props = ValueProps & EventProps

export class RuntimeFabricSettingsPage extends React.Component<Props, {}> {
  
  render() {
    return (
      <div className="runtime-fabric-settings-page" data-test-id="runtime-fabric-settings-page">
        <div className="runtime-fabric-settings-page-icon" data-test-id="runtime-fabric-settings-page-icon">
          <RuntimeFabricSettingsIcon/>
        </div>
        <div className="runtime-fabric-settings-page-title-container" data-test-id="runtime-fabric-settings-page-title-container">
          <span className="runtime-fabric-settings-page-title" data-test-id="runtime-fabric-settings-page-title">
            Anypoint Monitoring is enabled by default for all Runtime Fabric applications.
          </span>
        </div>
      </div>
    )
  }
}
